export default __webpack_public_path__ + "static/media/sn23.e1a1c535.jpg";